export const BEST_MATCH = 'BEST_MATCH';
export const DISTANCE = 'DISTANCE';
